const registerErrors = {
  REGISTER_ERROR: '¡Oops! Tuvimos un problema con el registro. Por favor, vuelve a intentarlo más tarde.',
  EMAIL_ALREADY_TAKEN: '¡Oops! Este correo ya fue registrado.'
};

export default registerErrors;
